import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import UserIcon from "../../../public/images/user-icon.png";
import { cls } from 'app/utils';
import { getAge } from 'app/routes/Account/FamilyEdit/utils';

export default function Option(props: any) {
  const { t } = useTranslation();

  // CN-1323 (P7): a managed dependent (head_external_id present) has no email
  // exposed — show their age instead so coaches can tell family members apart.
  const isDependent = props.data.headExternalId != null;
  const age = props.data.birthdate ? getAge(props.data.birthdate) : null;
  const subLabel = isDependent
    ? age != null
      ? t("Age {{age}}", { age })
      : ""
    : props.data.email;

  return (
    <div
      className={cls(
        styles.option,
        props.isSelected && styles.selected,
        // CN-1323 (CFTB-3281): indent a family child nested under its head;
        // the last child closes the connecting line into a corner.
        props.data.isFamilyChild && styles.option_child,
        props.data.isLastFamilyChild && styles.option_child_last,
      )}
      onClick={() => props.selectOption(props.data)}
    >
      <div className={styles.option_info}>
        <div className={styles.user_avatar}>
          <img src={props.data.profilePicture || UserIcon} alt={props.data.label} />
        </div>
        <div className={styles.text_content}>
          <div className={cls("option__label", styles.option_label)}>{props.label}</div>
          <div className={styles.small_label}>{subLabel}</div>
        </div>
      </div>

      <div className={`${styles.selection_status} ${props.isSelected ? styles.selected : ''}`}>
        {props.isSelected ? <i className="ico ico-check" /> : <div className={styles.blank_selection} />}
      </div>
    </div>
  );
}
